import {useEffect, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {PrivateIp} from '../../Types/routerForms';
import {IP_REGEX, newLocalId} from '../../Utils/random';

interface AddPrivateIpModalProps {
  show: boolean;
  onHide: () => void;
  onAdd: (ip: PrivateIp) => void;
}

const AddPrivateIpModal = ({show, onHide, onAdd}: AddPrivateIpModalProps): JSX.Element => {
  const intl = useIntl();
  const [address, setAddress] = useState('');
  const [mask, setMask] = useState('255.255.255.0');
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (show) {
      setAddress('');
      setMask('255.255.255.0');
      setValidated(false);
    }
  }, [show]);

  const isAddressValid = IP_REGEX.test(address);
  const isMaskValid = IP_REGEX.test(mask);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setValidated(true);
    if (!isAddressValid || !isMaskValid) return;
    onAdd({id: newLocalId('ip'), address, mask});
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.ADD'})}
        </Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit} id="addPrivateIpForm">
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.IP'})}
            </Form.Label>
            <Form.Control
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="192.168.1.1"
              isInvalid={validated && !isAddressValid}
              required
            />
            <Form.Control.Feedback type="invalid">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VALIDATION.IP'})}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label className="required">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.MASK'})}
            </Form.Label>
            <Form.Control
              type="text"
              value={mask}
              onChange={(e) => setMask(e.target.value)}
              placeholder="255.255.255.0"
              isInvalid={validated && !isMaskValid}
              required
            />
            <Form.Control.Feedback type="invalid">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VALIDATION.MASK'})}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {intl.formatMessage({id: 'COMMON.CANCEL'})}
          </Button>
          <Button variant="primary" type="submit" form="addPrivateIpForm">
            {intl.formatMessage({id: 'COMMON.ADD'})}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddPrivateIpModal;
